import React from 'react'

import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import Logo from 'presentation/shared/components/Logo'
import { ReactComponent as MaintenanceBlockIllustration } from 'presentation/assets/illustrations/access-block-illustration.svg'
import { ReactComponent as CheckCircleIcon } from 'presentation/assets/icons/check-circle.svg'
import * as S from './styles'
import { useMedia } from 'presentation/utils/window-media'

const MaintenanceBlock = () => {
  const media = useMedia()

  return (
    <S.Wrapper>
      <S.Card>
        <S.LogoWrapper>
          <Logo size={media.sm ? 'large' : 'normal'} />
        </S.LogoWrapper>

        <S.Illustration>
          <MaintenanceBlockIllustration />
        </S.Illustration>

        <HeadingNew
          color="textPrimary"
          weight="bold"
          fontFamily="secondary"
          size={media.sm ? 'large' : 'medium'}
          style={{
            lineHeight: 1.3,
            textAlign: 'center'
          }}
        >
          Serviços digitais temporariamente indisponíveis
        </HeadingNew>

        <SupportTextNew
          color="textSecondary"
          fontFamily="secondary"
          textAligh="center"
          size={media.sm ? 'small' : 'xsmall'}
          style={{ lineHeight: 1.5 }}
        >
          Entre 14 e 16 de agosto, todos os serviços digitais do Meu Mater Dei
          estarão indisponíveis, pois estamos realizando uma atualização no
          sistema.
        </SupportTextNew>

        <S.ForecastWrapper>
          <SupportTextNew
            size="xxsmall"
            color="textDisabled"
            weight="bold"
            fontFamily="secondary"
            uppercase
            textAligh="center"
          >
            Previsão de retorno
          </SupportTextNew>
          <HeadingNew
            color="primary600"
            weight="bold"
            style={{ textAlign: 'center', fontSize: '1.75em' }}
          >
            17 de agosto
          </HeadingNew>
        </S.ForecastWrapper>

        <S.InfoCard>
          <S.InfoCardTitle>
            <CheckCircleIcon />
            <HeadingNew
              size="xsmall"
              color="success900"
              weight="bold"
              style={{ lineHeight: 1.4 }}
            >
              Atendimento presencial disponível
            </HeadingNew>
          </S.InfoCardTitle>
          <SupportTextNew
            size="xsmall"
            color="textPrimary"
            fontFamily="secondary"
            style={{ lineHeight: 1.5 }}
          >
            Os atendimentos em{' '}
            <SupportTextNew as="span" color="success900" weight="bold">
              todas as unidades
            </SupportTextNew>{' '}
            Mater Dei continuam{' '}
            <SupportTextNew as="span" color="success900" weight="bold">
              funcionando normalmente
            </SupportTextNew>
            , incluindo urgências e emergências.
          </SupportTextNew>
        </S.InfoCard>
      </S.Card>
    </S.Wrapper>
  )
}

export default MaintenanceBlock
